import i18next from "i18next"
import { catchError, getError, http } from "services/http"
import { ErrorFn, ErrorResponse } from "models"
import { BodyPostOrder, PostLabelCustomId, Product } from "../types"
import { getLabelOrderProductErrorMessage } from "./bikeLabelOrderErrorApi"

//API:Get List Label of Product
export const getLabelOrderProduct = async (): Promise<{ res: Product[] } & ErrorFn> => {
	const getLabelOrderProductError = (error: ErrorResponse) => {
		const errorCode = error?.code
		const errorMessage = getLabelOrderProductErrorMessage[errorCode]?.messageKey

		return errorMessage
			? { code: errorCode, message: i18next.t(errorMessage, { ns: "api" }) }
			: { code: errorCode, message: i18next.t("global_error", { ns: "api" }) }
	}
	const res = await http
		.get("obikeapi/auth_store/products")
		.then((res) => res.data)
		.catch((e) => catchError(e))

	return {
		res: res as unknown as Product[],
		getError: getError(res as unknown as ErrorResponse, getLabelOrderProductError),
	}
}

export const postLabelOrder = async (
	bodyPostOrder: BodyPostOrder
): Promise<{ res: PostLabelCustomId } & ErrorFn> => {
	const postLabelOrderProductError = (error: ErrorResponse) => {
		const errorCode = error?.code
		const errorMessage = getLabelOrderProductErrorMessage[errorCode]?.messageKey

		return errorMessage
			? { code: errorCode, message: i18next.t(errorMessage, { ns: "api" }) }
			: { code: errorCode, message: i18next.t("global_error", { ns: "api" }) }
	}

	const res = await http
		.post("obikeapi/auth_store/order", { ...bodyPostOrder })
		.then((res) => res.data)
		.catch((e) => catchError(e))

	return {
		res: res as unknown as PostLabelCustomId,
		getError: getError(res as unknown as ErrorResponse, postLabelOrderProductError),
	}
}
